import IInput from './props'
import {
  ComponentInput,
  Container,
  Error,
  Label
} from './styles'

const Input = ({
  error,
  onChange,
  onBlur,
  name,
  label,
  placeholder,
  type,
  value,
  disabled,
}: IInput) => {
  const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 14))
  const formatDate = `${maxDate.getFullYear()}-${(maxDate.getMonth() + 1).toString().padStart(2, '0')}-${maxDate.getDate().toString().padStart(2, '0')}`

  return (
    <Container>
      <ComponentInput
        error={error}
        id={name}
        name={name}
        disabled={disabled}
        onChange={(e: any) => onChange?.(e.target.value)}
        onBlur={(e: any) => onBlur?.(e.target.value)}
        placeholder={placeholder}
        type={type}
        value={value}
        max={type === 'date' ? formatDate : ''}
      />

      {label && (
        <Label>{label}</Label>
      )}

      {error && <Error>{error}</Error>}
    </Container>
  )
}

Input.defaultProps = {
  error: '',
  type: 'text',
}

export default Input
